import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faTimes, faCheck } from "@fortawesome/pro-regular-svg-icons";

const ButtonRound = ({ icon, type = "button", size, color, className, onClick, tabIndex }) => {
  const renderIconOfType = () => {
    switch (icon) {
      case "check":
        return <FontAwesomeIcon size={size} icon={faCheck} />;
      case "add":
        return <FontAwesomeIcon size={size} icon={faPlus} />;
      case "remove":
        return <FontAwesomeIcon size={size} icon={faMinus} />;
      case "close":
        return <FontAwesomeIcon size={size} icon={faTimes} />;
      default:
        return null;
    }
  };

  const buttonClassnames = classnames(
    "rounded-circle position-relative d-flex justify-content-center align-items-center",
    className,
    {
      [`rounded-circle-${size}`]: size,
    }
  );

  return (
    <button
      tabIndex={tabIndex}
      type={type}
      className={buttonClassnames}
      onClick={onClick}
      style={{ backgroundColor: color, border: "none" }}
    >
      <div className="position-absolute d-inline-flex">{renderIconOfType()}</div>
    </button>
  );
};

ButtonRound.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  tabIndex: PropTypes.number,
};

export default ButtonRound;
